import { useTheme } from "@mui/material";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";
import { TagChip } from "../components/general";

/**
 * useFilteredTag - Colors "matched" TagChip using "autosuggest-highlight" package.
 *
 * @returns {function} - function to color TagChip whose "name" matches query.
 */
export function useFilteredTag() {
  const theme = useTheme();
  const getFilteredTag = (tag, query) => {
    const matches = match(tag?.name, query, { insideWords: true });
    const parts = parse(tag?.name, matches);
    return (
      <TagChip
        label={
          <div>
            {parts.map((part, index) => (
              <span
                key={index}
                style={{
                  fontWeight: "bold",
                  color: part.highlight && theme.palette.textMatchColor,
                }}
              >
                {part.text}
              </span>
            ))}
          </div>
        }
        color={tag?.color}
      />
    );
  };

  return {
    getFilteredTag,
  };
}

export default useFilteredTag;
